var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReportDriveColoured(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 57,
    viewBox: "0 0 58 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.83875 23.8331C8.3375 22.4081 9.62 21.375 11.1875 21.375H50.375V17.8125C50.375 15.8531 48.7719 14.25 46.8125 14.25H23.3356L17.2794 8.15812C16.6381 7.51687 15.7475 7.125 14.75 7.125H4.0625C2.10312 7.125 0.5 8.72812 0.5 10.6875V45.7425L7.80312 23.8331H7.83875ZM57.5 28.5C57.5 26.5406 55.8969 24.9375 53.9375 24.9375H14.75C13.1825 24.9375 11.8644 25.9706 11.4012 27.3956L4.27625 48.7706C4.13375 49.0913 4.0625 49.4831 4.0625 49.875C4.0625 51.8344 5.66563 53.4375 7.625 53.4375H46.8125C48.38 53.4375 49.6981 52.4044 50.1613 50.9794L57.2863 29.6044C57.4288 29.2838 57.5 28.8919 57.5 28.5Z",
    fill: "url(#paint0_linear_3774_58464)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3774_58464",
    x1: 13.5502,
    y1: 43.6651,
    x2: 37.5834,
    y2: 7.92345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0ADEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576485,
    stopColor: "#15C244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9F025"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportDriveColoured);
export default __webpack_public_path__ + "static/media/reportDriveColoured.d1e8b33de3f53c8cdb00c33875f08c59.svg";
export { ForwardRef as ReactComponent };